import { createWebHistory, createRouter } from "vue-router";
import { useUserStore } from '@/stores/user'


const routes = [ 
  {
    path: "/",
    name: "index",
    component: () => import('@/pages/index/index-four.vue'),
  },
  /* {
    path: "/home1",
    name: "home1",
    component: () => import('@/pages/index/index.vue'),
  }, 
  {
    path: "/home2",
    name: "home2",
    component: () => import('@/pages/index/index-two.vue'),
  },
  {
    path: "/home3",
    name: "home3",
    component: () => import('@/pages/index/index-three.vue'),
  }, */
  {
    path: "/participate/:nom",
    name: "participate",
    component: () => import('@/components/participate.vue'),
  },
  {
    path: "/postuler/:nom",
    name: "postuler",
    component: () => import('@/components/postuler.vue'),
  },
  {
    path: "/formations",
    name: "formations",
    component: () => import('@/pages/explore/formations.vue'),
  }, 
  {
    path: "/become-partner",
    name: "become-partner",
    component: () => import('@/pages/explore/formations-partner.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/devenir-formateur",
    name: "devenir-formateur",
    component: () => import('@/components/become-partner.vue'),
    meta: { requiresAuth: true, checkUserFonction: true }
  },
  {
    path: "/mesFormations",
    name: "mesFormations",
    component: () => import('@/pages/explore/mesFormations.vue'),
    meta: { requiresAuth: true, checkUserFonction: false }
  },
  
  {
    path: "/ajouterFormation",
    name: "ajouterFormation",
    component: () => import('@/pages/explore/ajouterFormation.vue'),
    meta: { requiresAuth: true, checkUserFonction: false }
  },
  {
    path: "/formation/:id",
    name: "formation-detail",
    component: () => import('@/pages/explore/formation-detail.vue'),
    meta: { requiresAuth: true }
  }, 
  {
    path: "/formation/:id/modules/",
    name: "modules",
    component: () => import('@/pages/explore/modules.vue'),
    meta: { requiresAuth: true }
  },  
  {
    path: "/item-detail",
    name: "item-details",
    component: () => import('@/pages/explore/vr-detail.vue'),
  },
  {
    path: "/vr/:id",
    name: "vr-detail",
    component: () => import('@/pages/explore/vr-detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/vr",
    name: "vr",
    component: () => import('@/pages/explore/vr.vue'),
  },
  {
    path: "/services/:name",
    name: "services",
    component: () => import('@/pages/services/dev.vue'),
    meta: { requiresAuth: true }
  },  
  {
    path: "/user-profile/:id",
    name: "user-profile",
    component: () => import('@/pages/creators/user-profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/update-profile/:id",
    name: "update-profile",
    component: () => import('@/pages/creators/update-profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/cloud",
    name: "cloud",
    component: () => import('@/pages/services/cloud.vue'),
  },
  {
    path: "/message",
    name: "message",
    component: () => import('@/pages/special-pages/error.vue'),
  },
  {
    path: "/evenements",
    name: "evenements",
    component: () => import('@/pages/explore/evenements.vue'),
  }, 
  {
    path: "/contact",
    name: "contact",
    component: () => import('@/pages/contact.vue'),
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: () => import('@/pages/aboutus.vue'),
  },    
  {
    path: "/terms",
    name: "terms",
    component: () => import('@/pages/terms.vue'),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import('@/pages/privacy.vue'),
  },
  {
    path: "/helpcenter-overview",
    name: "helpcenter-overview",
    component: () => import('@/pages/help-center/helpcenter-overview.vue'),
  },
  {
    path: "/helpcenter-faqs",
    name: "helpcenter-faqs",
    component: () => import('@/pages/help-center/helpcenter-faqs.vue'),
  },
  {
    path: "/helpcenter-guides",
    name: "helpcenter-guides",
    component: () => import('@/pages/help-center/helpcenter-guides.vue'),
  },
  {
    path: "/helpcenter-support",
    name: "helpcenter-support",
    component: () => import('@/pages/help-center/helpcenter-support.vue'),
  },
  {
    path: "/blogs",
    name: "blogs",
    component: () => import('@/pages/blog/blogs.vue'),
  },
  {
    path: "/blog-detail",
    name: "blog-details",
    component: () => import('@/pages/blog/blog-detail.vue'),
  },
  {
    path: "/blog-detail/:id",
    name: "blog-detail",
    component: () => import('@/pages/blog/blog-detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "login",
    component: () => import('@/pages/auth-pages/login.vue'),
    meta: { checkUser: true }
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import('@/pages/auth-pages/signup.vue'),
    meta: { checkUser: true }
  },
  {
    path: "/signup-success",
    name: "signup-success",
    component: () => import('@/pages/auth-pages/signup-success.vue'),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import('@/pages/auth-pages/reset-password.vue'),
  },
  {
    path: "/lock-screen",
    name: "lock-screen",
    component: () => import('@/pages/auth-pages/lock-screen.vue'),
  },
  {
    path: "/comingsoon",
    name: "comingsoon",
    component: () => import('@/pages/special-pages/comingsoon.vue'),
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: () => import('@/pages/special-pages/maintenance.vue'),
  },
  {
    path: "/thankyou",
    name: "thankyou",
    component: () => import('@/pages/special-pages/thankyou.vue'),
  },
  {
    path: "/:error(.*)",
    name: "error",
    component: () => import('@/pages/special-pages/error.vue'),
  },

  
  
];




const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()

  if (to.meta.requiresAuth && !userStore.userId) {
    await userStore.fetchUser()

    if (userStore.userId === 0) {
       return next({ name: 'login' }) 
    }
    
  }

  if (to.meta.checkUser) {
    await userStore.fetchUser() 
    if (userStore.userId !== 0) {
      return next({ name: 'index' }) 
    }
  }

  if (to.meta.checkUserFonction) {
    await userStore.fetchUser() 
    if (userStore.user.fonction !== null) {
      return next({ name: 'index' }) 
    }
  }

  next()


})

  router.onError((error) => {
  // Vérifie si l'erreur est liée au chargement d'un chunk (CSS ou JS)
  if (error.name === 'ChunkLoadError' || /loading chunk/i.test(error.message)) {
    // Évite les boucles infinies de rechargement
    const hasReloaded = window.sessionStorage.getItem('last-chunk-error-reload');
    const now = Date.now();

    // Si on n'a pas rechargé dans les 10 dernières secondes
    if (!hasReloaded || now - parseInt(hasReloaded) > 10000) {
      window.sessionStorage.setItem('last-chunk-error-reload', now.toString());
      window.location.reload();
    }
  }
});
export default router;